export default "__VITE_ASSET__DOLp0SO5__"